/** Previous / next controls for stepping through a list of detail pages. */

export function SiblingNav({
  currentId,
  siblingIds,
  onGo,
  busy,
  compact,
}: {
  currentId: number;
  siblingIds: number[];
  onGo: (id: number) => void;
  busy?: boolean;
  compact?: boolean;
}) {
  const index = siblingIds.indexOf(currentId);
  if (siblingIds.length < 2 || index < 0) return null;

  const prevId = index > 0 ? siblingIds[index - 1] : null;
  const nextId = index < siblingIds.length - 1 ? siblingIds[index + 1] : null;

  return (
    <div
      className="sibling-nav row between"
      style={{
        marginBottom: compact ? 0 : "0.75rem",
        marginTop: compact ? "0.85rem" : 0,
      }}
    >
      <button
        type="button"
        className={compact ? "btn btn-ghost" : "btn btn-ghost btn-sm"}
        disabled={!prevId || busy}
        onClick={() => prevId && onGo(prevId)}
      >
        ← Prev
      </button>
      {!compact && (
        <span className="muted sibling-nav-count">
          {index + 1} / {siblingIds.length}
        </span>
      )}
      <button
        type="button"
        className={compact ? "btn btn-ghost" : "btn btn-ghost btn-sm"}
        disabled={!nextId || busy}
        onClick={() => nextId && onGo(nextId)}
      >
        Next →
      </button>
    </div>
  );
}
